import { authHeader, utils } from "../helpers/";

const apiUrl = process.env.REACT_APP_API_URL;

export interface BasicStudent {
    id: number;
    name: string;
    email: string;
    avatar: string | null;
}

export const studentsService = {
    getAll,
    getAvailable,
    matchAvailable,
};

function getAll(): Promise<BasicStudent[]> {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader(),
    };

    return fetch(`${apiUrl}/api/students`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data as BasicStudent[];
        })
        .catch((error) => Promise.reject(error));
}

function getAvailable(classroomId: number, search: string): Promise<BasicStudent[]> {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: authHeader(),
    };

    const query = new URLSearchParams({ search }).toString();

    return fetch(`${apiUrl}/api/classrooms/${classroomId}/available-students?${query}`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data as BasicStudent[];
        })
        .catch((error) => Promise.reject(error));
}

function matchAvailable(classroomId: number, emails: string[]): Promise<BasicStudent[]> {
    const requestOptions: RequestInit = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify({ emails }),
    };

    return fetch(`${apiUrl}/api/classrooms/${classroomId}/available-students/match`, requestOptions)
        .then(utils.handleResponse)
        .then((data) => {
            return data as BasicStudent[];
        })
        .catch((error) => Promise.reject(error));
}
